import { Box, Skeleton } from "@mui/material"
import PatientDetails from "./PatientDetails"
import TabsDetail from "./TabsDetail"
import { useDispatch, useSelector } from "react-redux"
import { getPatientDetailsById } from "../../../../slices/QRCode"
import { useParams } from "react-router"
import { useEffect, useState } from "react"
import { fetchV2V, setCoaFormData, clearCoaFormData,selectFollowCycle, storePatientData } from "../../../../slices/common"
import { dateFormater } from "../../../../utils/common/utils"
import { getCoaFormDetailsById } from "../../../../slices/qualityControl";
import SubjectApi from "../../../../../services/subjectService"

const ViewDetails = () => {
  const dispatch = useDispatch();
  const [patientData, setPatientData] = useState({});
  const [cycleData, setCycleData] = useState([]);
  const [patientInfo, setPatientInfo] = useState({});
  const currentCycle = useSelector(selectFollowCycle)
  const [timeLineSkeletonLoading, setTimeLineSkeletonLoading] = useState(false);
  const [isSubjectLoading, setIsSubjectLoading] = useState(false);

  const { qrId } = useParams()
  /* ===================== SUBJECT ===================== */
  const fetchSubjectDetail = async (id) => {
    try {
      const res = await SubjectApi.getSubjectDetails(
        id ?? patientData?.patient_information?.id
      );
      return res?.data;
    } catch (err) {
      console.error(err);
    }
  };

  const fetchPatientDetail = async () => {
setIsSubjectLoading(true)

    try {
      const patientDetailsResponse = await dispatch(
        getPatientDetailsById(qrId)
      ).unwrap();
      const patientDetails = patientDetailsResponse?.data?.patient_information;
      const patientBasicInfo = {
        patientName: patientDetails?.name || "-",
        patientId: patientDetails?.patient_id || "-",
        id: patientDetails?.id,
        subject_id: patientDetails?.subject_id || patientDetails?.id,
        feasibility_assessment_id:
          currentCycle?.feasibility_assessments_id || patientDetails?.feasibility_assessment_id,
        inbond_form_id: currentCycle?.inbond_patients_id ?? null,
        hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
        logisticOperationId:
          patientDetailsResponse?.data?.logistics_operation_id ?? null,
        immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
        name: patientDetails?.name || "-", // Add name for ReprintComponent
        body_weight: patientDetails?.body_weight || 0, // Add weight for ReprintComponent
        dob: patientDetails?.dob || "-", // Add DOB for ReprintComponent
        disease: patientDetails?.disease || "-", // Add disease for ReprintComponent
        hospital: patientDetails?.hospital || "-", // Add hospital for ReprintComponent
      };

      setPatientInfo(patientBasicInfo);
      // ✅ fetch subject AFTER patient
      const subjectRes = await fetchSubjectDetail(patientDetailsResponse?.data?.patient_information?.id
        // patientDetails?.subject_id || patientDetails?.id
      );
      // ✅ subjectData is now meaningful
      const data = {
        ...patientDetailsResponse.data,
        life_status: subjectRes?.life_status,
        hospital_name: subjectRes?.investigator?.hospital_details?.name,
        principal_investigator: subjectRes?.investigator?.name,
        editor: subjectRes?.editor?.name

      };
setIsSubjectLoading(false)
      setPatientData(data);
      setPatientInfo(patientBasicInfo)
      // setPatientData(patientDetailsResponse.data)
      dispatch(storePatientData(patientDetailsResponse))
    } catch (error) {
      console.error('Error', error)
    }
    finally{
setIsSubjectLoading(false)

    }
  }
  useEffect(() => {
      if (!currentCycle?.coa_forms_id){  dispatch(clearCoaFormData());return}
    fetchCoaForms(currentCycle?.coa_forms_id, patientData)
  }, [currentCycle?.coa_forms_id])

  const getTimeLine = async (id) => {
    setTimeLineSkeletonLoading(true);
    try {
      const response = await dispatch(
        fetchV2V({
          portal_type: 2,
          patient_id: id ?? patientData?.patient_information?.id,
        })
      ).unwrap();
      // ✅ adjust based on API shape
      setCycleData(response?.data ?? []);
    } catch (err) {
      console.error(err);
    } finally {
      setTimeLineSkeletonLoading(false);
    }
  };

  useEffect(() => {
    if (qrId)
      fetchPatientDetail()
  }, [qrId])

  useEffect(() => {
    if (patientData?.patient_information?.id) {
      getTimeLine(patientData?.patient_information?.id);
    }
  }, [patientData]);


  const fetchCoaForms = async (coaFormId, patientData) => {
    try {
      const response = await dispatch(
        getCoaFormDetailsById(coaFormId)
      ).unwrap();
      if (response?.data) {
        const dataValues = response?.data
        const preFilledData = {
          product_name: patientData?.product_name || "",
          batch_no: currentCycle?.batch_no || "",
          immunoact_patient_id: patientData?.patientId || "",
          product_id: patientData?.product_id || patientData?.product_id || "",
          mfg_date: currentCycle?.mfg_at ? dateFormater(currentCycle?.mfg_at) : "",
          product_manufacturing_id: currentCycle?.product_manufacturing_id || "",
          expired_at: currentCycle?.mfg_at
            ? dateFormater(new Date(new Date(currentCycle?.mfg_at).setMonth(new Date(currentCycle?.mfg_at).getMonth() + 3)))
            : "",
        }
        dispatch(setCoaFormData({ ...dataValues, ...preFilledData }))

      }
    } catch (error) {
      console.error("Error fetching COA form details:", error);
    }
  };

  return (
    <>
      <Box sx={{ p: 4 }}>
        <Box sx={{ mb: 2 }}>
          {isSubjectLoading ? <div className="border rounded-md flex gap-2 flex-col bg-[#F0F1F5] p-3">
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="50%" />
          </div> : <PatientDetails patientData={patientData} cycleData={cycleData} />}
        </Box>
        <TabsDetail patientData={patientData} patientInfo={patientInfo} timeLineSkeletonLoading={timeLineSkeletonLoading} />
      </Box>
    </>
  )
}

export default ViewDetails